import { colors } from '../../../../shared'
import { LKDate } from 'loankeeper-common/helpers/Date'

export const config = {
  gridIdentity: { formName: 'frm_loan_view', objectName: 'dbgrd_reminders' },

  getRowStyle: ({
    node: {
      data: { StateID, PriorityID, TypeID },
    },
  }) => {
    let styles = {} as Record<string, any>

    if (StateID !== 1) {
      styles = { backgroundColor: colors.grey }
    }

    if (PriorityID === 2) {
      styles.color = colors.red
    }

    if (PriorityID === 3) {
      styles.color = colors.ink
    }

    if (TypeID === 3) {
      // Think we should add in styles
      styles = { backgroundColor: '#a0c8f0' }
    }

    return styles
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    CDate: { valueFormatter: ({ value }) => LKDate.from(value).toTString() },
    GDate: { valueFormatter: ({ value }) => LKDate.from(value).toString() },
  },
}
